module.exports = __webpack_public_path__ + "img/FAQ-img.8d1a93d0.png";